/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_IssuesInputs */

const en_experience_issues = /** @type {(inputs: Experience_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our server is currently experiencing issues or something else happened. Please try again later.`)
};

const nl_experience_issues = /** @type {(inputs: Experience_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze server ondervindt momenteel problemen of er is iets anders gebeurd. Probeer het later opnieuw.`)
};

/**
* | output |
* | --- |
* | "Our server is currently experiencing issues or something else happened. Please try again later." |
*
* @param {Experience_IssuesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const experience_issues = /** @type {((inputs?: Experience_IssuesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_IssuesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_experience_issues(inputs)
	return en_experience_issues(inputs)
});